import { Accordion } from '@zorro/design-system/v2/Accordion';
import { Alert } from '@zorro/design-system/v2/Alert';
import { EmptyState } from '@zorro/design-system/v2/EmptyState';
import { useMonolithQuery } from '@zorro/web/ui-utils';

import { FullPageLoader } from '../../../../FullPageLoader';
import { EmployeeActivityLogRow } from './EmployeeActivityLogRow';

type Props = {
  onboardingPeriodId: string;
  isDon: boolean;
};

export const EmployeeActivityLogs = ({ onboardingPeriodId, isDon }: Props) => {
  const {
    data: activityLogGroups,
    isLoading,
    isError,
  } = useMonolithQuery({
    method: isDon
      ? 'enrollmentActivityLogControllerFindManyForEmployerAdmin'
      : 'enrollmentActivityLogControllerFindMany',
    params: [onboardingPeriodId],
  });
  if (isError) {
    return (
      <Alert variant="error" title="Failed to load enrollment activity">
        Could not fetch the activity log for this enrollment. Try refreshing.
      </Alert>
    );
  }

  if (isLoading || !activityLogGroups) {
    return <FullPageLoader />;
  }

  if (activityLogGroups.length === 0) {
    return <EmptyState title="No enrollment activity yet" />;
  }

  return (
    <Accordion multiple styleVariant="underlined" size="sm">
      {activityLogGroups.map((group) => (
        <EmployeeActivityLogRow key={group.id} group={group} />
      ))}
    </Accordion>
  );
};
